<template>
    <hsc-menu-style-white class="col-span-2 text-xs">
        <hsc-menu-button-menu>
            <app-button icon="icon-user" size="mini" variant="borderless" :title="$t('toolbar.accountMenu')">
                <icon-chevron-down width="16px" heigth="16px" />
            </app-button>
            <template slot="contextmenu">
                <hsc-menu-item :label="$t('user.title')" @click="navigateTo({ name: 'user' })" />
                <hsc-menu-item
                    :label="
                        $i18n.locale === 'fr-FR'
                            ? $t('user.languageFR')
                            : $i18n.locale === 'fr-FR'
                            ? $t('user.languageEN')
                            : $t('user.languageQC')
                    "
                >
                    <template>
                        <hsc-menu-item :label="$t('user.languageFR')" @click="setLangTo('fr-FR')" />
                        <hsc-menu-item :label="$t('user.languageEN')" @click="setLangTo('en-US')" />
                        <hsc-menu-item :label="$t('user.languageQC')" @click="setLangTo('fr-CA')" />
                    </template>
                </hsc-menu-item>
                <hsc-menu-item
                    v-if="organizations.length === 1"
                    :label="$t('organizations.menuTitle')"
                    @click="navigateTo({ name: 'organizationOffer', params: { organizationId: organizations[0].id } })"
                />
                <template v-else-if="organizations.length > 1">
                    <hsc-menu-item :label="$t('organizations.menuTitle')">
                        <hsc-menu-item
                            :label="organization.name + (organization.city ? ' - ' + organization.city : '')"
                            v-for="organization in organizations"
                            :key="organization.id"
                            @click="
                                navigateTo({ name: 'organizationOffer', params: { organizationId: organization.id } })
                            "
                        />
                    </hsc-menu-item>
                </template>
                <hsc-menu-item :label="$t('toolbar.logout')" @click="logout()" />
            </template>
        </hsc-menu-button-menu>
    </hsc-menu-style-white>
</template>
<script>
import AppSelect from './appSelect/AppSelect';
import database from '@/rxdb/database';
import { getOrganizations } from '@/features/organizations/organizations.service';
import AppButton from '@/components/appButton/AppButton.vue';
import IconAccountArrowDown from '@/icons/IconAccountArrowDown.vue';
import IconChevronDown from '@/icons/IconChevronDown.vue';
import i18nService from '@/services/i18n.service';
export default {
    name: 'user-dropdown',
    components: { IconChevronDown, IconAccountArrowDown, AppButton, AppSelect },
    data() {
        return {
            organizations: [],
        };
    },
    async created() {
        this.organizations = await getOrganizations();
    },
    methods: {
        setLangTo(lang) {
            i18nService.setLangTo(this.$root, lang);
        },
        navigateTo(route) {
            return this.$router.push(route);
        },
        logout: function () {
            localStorage.removeItem('token');
            database.logout();
            this.$router.push({
                name: 'login',
            });
        },
    },
};
</script>
